import { z } from 'zod';

import { optionalEnum } from '../../../utils.js';
import { ApiInstanceFhirMethod } from '../../orchestrator/apiInstanceFhir.js';
import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';
import { ResponseBodyFormat } from '../rest/config.js';

export const MontageOnBaseBlockConfigSchema = z.object({
  apiInstanceId: z.uuid(),
  apiInstanceBaseUrl: z.string().url().optional(),
  method: z.nativeEnum(ApiInstanceFhirMethod),
  endpoint: z
    .string()
    .min(1)
    .transform((endpoint) => (endpoint.startsWith('/') ? endpoint : `/${endpoint}`)),
  headers: z
    .array(
      z.object({
        key: z.string().min(1, { message: 'Header key cannot be empty.' }),
        value: z.string().min(1, { message: 'Header value cannot be empty.' }),
      })
    )
    .refine(
      (headers) =>
        new Set(headers.map((header) => `${header.key}-${header.value}`)).size === headers.length,
      'Headers cannot have duplicates'
    )
    .optional(),
  responseBodyFormat: optionalEnum(ResponseBodyFormat, ResponseBodyFormat.AutoDetect),
  body: z.string().optional(),
});

export type MontageOnBaseBlockConfig = z.infer<typeof MontageOnBaseBlockConfigSchema>;

export const MontageOnBaseBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.MontageOnBase),
  config: MontageOnBaseBlockConfigSchema,
});

export type MontageOnBaseBlock = z.infer<typeof MontageOnBaseBlockSchema>;
